interface IProps {
  type: string
  value: string
  name: string
  className: string | null | undefined
  label: string
  onHandleChange: (arg: string) => void
  error: any
  disabled: boolean
}

const TestField = ({
  type,
  value,
  onHandleChange,
  className = "",
  error = "" || {},
  name = "",
  label = "",
  disabled,
}: IProps) => {

  const errorPrint = () => {
    if (typeof error === "string") {
      return <span className="input-item__error error mt-1">{error}</span>
    } else {
      return (
        <span className="input-item__error error mt-1">{handleErrors()}</span>
      )
    }
  }

  const handleErrors = () => {
    if (error?.errors.hasOwnProperty(name)) {
      return error.errors[name]
    }
  }

  const handleErrors2 = () => {
    if (error?.errors.hasOwnProperty(name)) {
      return true
    }
  }

  const addErrorClass = () => {
    if (typeof error === "string") {
      return `${className} ${error && "input-error"}`
    } else {
      return `${className} ${handleErrors2() && "input-error"}`
    }
  }

  return (
    <div className="test-input input-item">
      <input
        name={name}
        type={type}
        disabled={disabled}
        value={value}
        className={addErrorClass()}
        onChange={(event) => {
          onHandleChange(event.target.value)
        }}
      />

      <label htmlFor="">{label}</label>

      {error && errorPrint()}
    </div>
  )
}

export default TestField
